export default {"src":"/_next/static/media/allsecure.875fe288.svg","height":124,"width":305,"blurWidth":0,"blurHeight":0};